module.exports = __webpack_public_path__ + "img/I-09003_00.8a23d3ea.jpg";